import React from 'react';
import { STable } from '../../shared/UserStatistic/styled';

const PricesTable: React.FC = () => {
  return (
    <STable>
      <thead>
        <tr>
          <th>Бесплатно</th>
          <th>Стандарт</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="Бесплатно">0$</td>
          <td data-label="Стандарт">
            <b>3$</b> / за <b>1</b> пользователя, <br /> не считая админа
          </td>
        </tr>
        <tr>
          <td data-label="Бесплатно">
            Любое количество досок и задач, использование системы как менеджера задач без трекинга
            времени
          </td>
          <td data-label="Стандарт">
            Трекинг времени, подробная статистика со скриншотами по месяцам и дням каждого
            пользователя
          </td>
        </tr>
      </tbody>
    </STable>
  );
};

export default PricesTable;
